import { Col, Dropdown, Popconfirm, Row } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { NumericFormat } from 'react-number-format';
import { useLocation } from 'react-router-dom';
import { ReactComponent as MoreIcon } from '../../../../../assets/icons/dots-v.svg';
import { convertDateESTToUTCToUserLocal, getDateLabel } from '../../../../../utilz/dates';
import { routeFileSelector } from '../../../../../utilz/i18n';
import Button from '../../../../components/Buttons/Button';
import Checkbox from '../../../../components/Inputs/Checkbox';
import BatchLabel from '../../../../components/Labels/BatchLabel';
import PrimaryLabel from '../../../../components/Labels/PrimaryLabel';
import Paper from '../../../../components/Paper/Paper';
import TMSFiledCard from '../../../common/components/TMSFiledCard';

const OverChargeCard = ({ data, handleCardClick, isSelected, onSelect = () => {}, handleDelete = () => [] }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  const handleCheckBoxClick = (e) => {
    e.stopPropagation();
    onSelect(data.fbocKey, isSelected);
  };
  const submittedDateLabel = getDateLabel(convertDateESTToUTCToUserLocal(data.dateSubmitted));

  const menu = [
    {
      key: '2',
      label: (
        <Popconfirm
          placement="topRight"
          title={t('translation:default.fields.deleteConfirm.title')}
          onConfirm={() => handleDelete(data.fbocKey)}
          okText={t('translation:default.options.yes')}
          cancelText={t('translation:default.buttons.cancel')}
          overlayClassName=""
        >
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a>{t('translation:default.buttons.delete')}</a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <Paper className={`shipment-card border-muted ${isSelected ? 'selected' : ''}`}>
      <Row className="py-14 flex-nowrap " gutter={15} onClick={handleCardClick(data.fbocKey)}>
        <Col className="pl-20">
          <div className="text-center">
            <Checkbox onClick={handleCheckBoxClick} checked={isSelected} />
          </div>
        </Col>
        <Col className="flex-1">
          <Row gutter={30}>
            <Col sm={6}>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.claimNumber')}>
                <PrimaryLabel className="text-highlight">{data.customerClaimNo}</PrimaryLabel>
              </TMSFiledCard>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.transportationProvider.label')}>
                {data.carrierName}
              </TMSFiledCard>
              <TMSFiledCard title={t('translation:default.fields.claimStatus')}>
                <BatchLabel>{data.claimStatusDescription}</BatchLabel>
              </TMSFiledCard>
            </Col>
            <Col sm={6}>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.overchargeAmount')}>
                <PrimaryLabel className="text-danger">
                  <NumericFormat
                    thousandsGroupStyle="lakh"
                    displayType="text"
                    value={String(data.overchargeAmount)}
                    thousandSeparator
                    fixedDecimalScale
                    decimalScale={2}
                  />
                </PrimaryLabel>
              </TMSFiledCard>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.recoveryAmount')}>
                <PrimaryLabel className="text-success">
                  <NumericFormat
                    thousandsGroupStyle="lakh"
                    displayType="text"
                    value={String(data.recoveryAmount)}
                    thousandSeparator
                    fixedDecimalScale
                    decimalScale={2}
                  />
                </PrimaryLabel>
              </TMSFiledCard>
              <TMSFiledCard title={t('translation:default.fields.auditedBy')}>{data.auditedBy}</TMSFiledCard>
            </Col>
            <Col sm={6}>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.preparedBy')}>
                {data.preparedBy}
              </TMSFiledCard>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.submittedBy')}>
                {data.submittedBy}
              </TMSFiledCard>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.submittedDate')}>
                {submittedDateLabel}
              </TMSFiledCard>
              <TMSFiledCard title={t('translation:default.fields.amendmentDate')}>
                {getDateLabel(data.ammendmentDate)}
              </TMSFiledCard>
            </Col>
            <Col sm={6}>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.reason.label')}>
                {data.reasonCodeDesc}
              </TMSFiledCard>
              <TMSFiledCard containerClass="mb-15" title={t('translation:default.fields.claimType')}>
                {data.claimTypeDesc}
              </TMSFiledCard>
              <TMSFiledCard containerClass={''} title={t('translation:default.fields.closedDate')}>
                {getDateLabel(data.closedDate)}
              </TMSFiledCard>
            </Col>
          </Row>
        </Col>
      </Row>
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: <explanation> */}
      <div className="more-button-container" onClick={(e) => e.stopPropagation()}>
        <Dropdown menu={{ items: menu }} placement="bottomRight">
          <Button ghost className="bg-none border-none w-0 p-0 shadow-none" size="small" shape="circle" type="ghost">
            <MoreIcon />
          </Button>
        </Dropdown>
      </div>
    </Paper>
  );
};

export default OverChargeCard;
